<script setup lang="ts">
import { computed } from "vue";

import { ASCENDING, NO_SORT, setSort, SORT_TO_NEXT_SORT_MAP, sortDirection, sortIndex } from "~/common/sort";
import { SortAscendingIcon, SortDescendingIcon } from "~/icons";
import { useAppStore } from "~/stores";

const props = defineProps<{
  propertyDuid: string;
}>();

const appStore = useAppStore();

const activeSortDirection = computed(() => sortDirection(props.propertyDuid));

const isSortActive = computed(() => activeSortDirection.value !== NO_SORT);

const index = computed(() => sortIndex(props.propertyDuid));

const handleSortClick = () =>
  setSort(SORT_TO_NEXT_SORT_MAP.get(activeSortDirection.value) ?? NO_SORT, props.propertyDuid);
</script>

<template>
  <div
    v-if="isSortActive"
    class="flex cursor-pointer items-center gap-0.5 rounded text-vlt hover:text-lt"
    @click="handleSortClick"
    @keydown.enter="handleSortClick">
    <component :is="activeSortDirection === ASCENDING ? SortAscendingIcon : SortDescendingIcon" class="icon-sm" />
    <span v-if="appStore.sorts.length > 1">{{ index }}</span>
  </div>
</template>
